import type { OrigemAlerta, SeveridadeAlerta, StatusAlerta } from '@/api/generated/model';

export const SEVERIDADES: readonly SeveridadeAlerta[] = ['CRITICO', 'ERRO', 'AVISO'];
export const STATUS: readonly StatusAlerta[] = ['ABERTO', 'RESOLVIDO', 'SILENCIADO'];
export const ORIGENS: readonly OrigemAlerta[] = ['BACKEND', 'FRONTEND', 'INTEGRACAO'];

export const ROTULO_SEVERIDADE: Record<SeveridadeAlerta, string> = {
  CRITICO: 'Crítico',
  ERRO: 'Erro',
  AVISO: 'Aviso',
};

/** Cor por severidade — o crítico precisa saltar da tabela. */
export const CLASSE_SEVERIDADE: Record<SeveridadeAlerta, string> = {
  CRITICO: 'bg-destructive text-destructive-foreground border-transparent',
  ERRO: 'text-orange-600 border-orange-600/40',
  AVISO: 'text-muted-foreground',
};

export const ROTULO_STATUS: Record<StatusAlerta, string> = {
  ABERTO: 'Aberto',
  RESOLVIDO: 'Resolvido',
  SILENCIADO: 'Silenciado',
};

export const ROTULO_ORIGEM: Record<OrigemAlerta, string> = {
  BACKEND: 'API',
  FRONTEND: 'Navegador',
  INTEGRACAO: 'Integração',
};

/**
 * Filtro de severidade que a tela abre: erro e crítico. Os avisos (4xx) são
 * muitos e quase sempre uso normal — ficam a um clique, no "Todas".
 */
export const FILTRO_PADRAO_DE_SEVERIDADE = 'CRITICO,ERRO';

export function dataHora(iso: string): string {
  return new Date(iso).toLocaleString('pt-BR', { dateStyle: 'short', timeStyle: 'medium' });
}

/** JSON indentado para os blocos de requisição e resposta. */
export function jsonLegivel(valor: unknown): string {
  if (valor === null || valor === undefined) return '—';
  try {
    return JSON.stringify(valor, null, 2);
  } catch {
    return String(valor);
  }
}
